export default __webpack_public_path__ + "static/media/partners2.25a25e0b.png";